export default "__VITE_ASSET__D12o2IE2__"